import getPathToStaticAsset from "./env_helpers/getPathToStaticAsset";
class Environment {
  constructor() {
    this.is_promo = null;
    this.is_site = null;
    this.is_gc = null;
    this.lang = this._getEnvLang();
    this.territory = this.getTerritory();
    this.MYGAMES = "mygames";
    this.MAILRU = "mailru";
    this.VKPLAY = "vkplay";
  }

  /**
   * Is it site environment?
   * - result cannot change, so just cache it on first call
   * @return {boolean}
   */
  isSite() {
    if (this.is_site === null) {
      this.is_site = !this.isPromoPage();
    }
    return this.is_site;
  }
  /**
   * Is it promo page environment?
   * - result cannot change, so just cache it on first call
   * @return {boolean}
   */
  isPromoPage() {
    if (this.is_promo === null) {
      this.is_promo = /^.+(\/promo\/).+$/.test(location.href);
    }
    //TODO It's a small ugly hack, we should delete it when main site will be ready.
    if (location.href.includes("d1.my.games")) {
      this.is_promo = true;
    }
    return this.is_promo;
  }
  /**
   * Is it GC environment?
   * - result cannot change, so just cache it on first call
   * @return {boolean}
   */
  isGcEnv() {
    if (this.is_gc === null) {
      this.is_gc = /my\.games/.test(location.host) || /vkplay\.ru/.test(location.host);
    }
    return this.is_gc;
  }

  /**
   * Return main site page URL (https://cb.mail.ru for example)
   * @return {string}
   */
  getHomePage() {
    return `${location.origin}/${this.isMyGames() ? this.getLang() + "/" : ""}`;
  }

  getTerritory() {
    if (typeof window !== "undefined" && window.APP_ENV && window.APP_ENV.territory) {
      return window.APP_ENV.territory;
    }
    if (process.env.TERRITORY) {
      return process.env.TERRITORY;
    }
  }

  /**
   *
   * @returns {object} object like {base: "http://cb.mydev", api: "http://cb.mydev/gw", sdc: "https://auth-ac.my.games/sdc?from="}
   */
  getUrls() {
    if (window.APP_ENV && window.APP_ENV.urls) {
      return window.APP_ENV.urls;
    }
    //support sdc and api URL for non-site repos (promos etc)
    return {
      base: this.getHomePage(),
      api: "/gw",
      sdc: "https://auth-ac.my.games/sdc?from=" + encodeURIComponent(location.href),
    };
  }
  getLang() {
    return this._getEnvLang();
  }
  getSupportedLangs() {
    return window.APP_ENV.supported_locales;
  }
  getPosixLocale() {
    const locales = {
      en: "en_US",
      de: "de_DE",
      fr: "fr_FR",
      ru: "ru_RU",
      es: "es_ES",
      tr: "tr_TR",
      it: "it_IT",
      ja: "ja_JP",
      zh: "zh_CN",
      ko: "ko_KR",
      pt: "pt_PT",
    };
    return locales[this.getLang()];
  }

  /**
   * Now it's unsupported for static promo pages, be careful
   * @return {*}
   */
  getGaSettings() {
    return window.APP_ENV.addthis_ga;
  }
  isMyGames() {
    return this.getTerritory() === this.MYGAMES;
  }
  isMailru() {
    return this.getTerritory() === this.MAILRU;
  }
  isVkPlay() {
    return this.getTerritory() === this.VKPLAY;
  }

  /**
   * Currently can be used only for sites (laravel and nuxt)
   * example:
   * env.getPathToStaticAsset("/static/video/my_cool_video.mp4") -> https://my-cool-cdn.com/static/video/my_cool_video.mp4
   * @param {string} path_to_file path to your static asset
   * @param {string} env current environment. Possible values: client, server
   * @returns {string} Absolute path with cdn support(if needed)
   */
  getPathToStaticAsset(path_to_file, env = "client") {
    return getPathToStaticAsset(path_to_file, env);
  }
  /**
   *
   * @private
   */
  _getEnvLang() {
    if (
      typeof window !== "undefined" &&
      window.APP_ENV &&
      (window.APP_ENV.lang || window.APP_ENV.locale)
    ) {
      return window.APP_ENV.lang || window.APP_ENV.locale;
    }
    return "en";
  }
}

export default new Environment();
